import React, {useCallback, useEffect, useState} from 'react';
import arrow from "../../../../images/down.svg";
import {Field} from "formik";
import infoIcon from "../../../../images/info-circle.svg";
import ReactTooltip from "react-tooltip";
import {userApi} from "../../../../redux/user/user-api";
import {useTranslation} from "react-i18next";

const TripDetails = ({tripDetails, crewFile, setCrewFile, crew_list_file_link, setFieldValue,
                       handleChange, isInvite, errors, detailsInfoRef}) => {
  const [crewFileName, setCrewFileName] = useState(null)
  const {t} = useTranslation()
  console.log(crew_list_file_link)
  const fetchCrewFile = useCallback(async (crew_list_file_link) => {
    const response = await userApi.getFileInfo(crew_list_file_link)
    setCrewFileName(response.data.filename)
  }, [])
  useEffect(() => {
    if (crew_list_file_link) {
      fetchCrewFile(crew_list_file_link)
    }
  }, [])
  useEffect(() => {
    if(errors.tripDetails) {
      detailsInfoRef.current.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }, [errors.tripDetails])
  return (
    <div className="modal__section" ref={detailsInfoRef}>
      <input defaultChecked={true} checked={errors.tripDetails} id={'check4'} type="checkbox" className={'modal__check'}/>
      <label htmlFor={'check4'} className="modal__subTitle">
        <h6 className="modal__underTitle">{t('tripDetails')}:</h6>
        <div className="modal__collapse">
          <img src={arrow} alt=""/>
        </div>
      </label>
      <div className="modal__inputs">
        <div className="modal__textareaItem">
          <Field component={'textarea'}
                 placeholder={t('tripDetailsHolder')}
                 id={'tripDetails'} value={tripDetails} onChange={e => {
            if (e.target.value.length < 200) {
              handleChange(e)
            }
          }}
                 className={`modal__textarea ${errors.tripDetails && 'modal__inputError'}`} maxLength={200}/>
        </div>
        {errors.tripDetails && <div className={'modal__inputItem mt-0'}>
          <p className="modal__errorText">{errors.tripDetails}</p>
        </div>}
        <div className="modal__uploadWrapper">
          <div className="modal__inputItem">
            <p className="modal__label">{t('crewList')}:</p>
            <div className="modal__upload">
              <div className="modal__uploadInner">
                <p className="modal__uploadText">{crewFile ? crewFile.name : crewFileName ?? t('fileNotChosen')}</p>
                <label htmlFor={'file'} className="modal__uploadButton">{t('chooseFile')}</label>
                <input onChange={(e) => setCrewFile(e.target.files[0])} id={'file'} type="file"
                       className={'modal__file'} accept={'image/jpg,image/png,image/jpeg,application/pdf'}/>
              </div>
              <div className="modal__row">
                <button data-tip data-for={'file'} className="modal__infoButton">
                  <img src={infoIcon} alt=""/>
                </button>
                <ReactTooltip className={'tooltip'} backgroundColor={'#F7F8FB'} id={'file'} place="left"
                              effect="solid">
                  {t('chooseFileFormat')}
                </ReactTooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(TripDetails);
